import { render, staticRenderFns } from "./PlatformButton.vue?vue&type=template&id=4684a7b2&scoped=true"
import script from "./PlatformButton.vue?vue&type=script&lang=ts"
export * from "./PlatformButton.vue?vue&type=script&lang=ts"
import style0 from "./PlatformButton.vue?vue&type=style&index=0&id=4684a7b2&prod&lang=scss&scoped=true"
import style1 from "./PlatformButton.vue?vue&type=style&index=1&id=4684a7b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684a7b2",
  null
  
)

export default component.exports